function initHeroVideos() {
    document.querySelectorAll('.about-video').forEach(function (video) {
        if (video.dataset.heroVideoInit) {
            return;
        }
        video.dataset.heroVideoInit = '1';

        const markReady = function () {
            video.classList.add('is-ready');
        };

        if (video.readyState >= 2) {
            markReady();
        } else {
            video.addEventListener('loadeddata', markReady, { once: true });
            video.addEventListener('canplay', markReady, { once: true });
        }

        const tryPlay = function () {
            const playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') {
                playPromise.catch(function () {});
            }
        };

        video.addEventListener('canplay', tryPlay, { once: true });
        tryPlay();
    });
}

document.addEventListener('DOMContentLoaded', initHeroVideos);
